import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

export default function Typography(theme: Theme) {
  return {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          // The app view heading is an <h1>; the variant only carries the styling.
          pageTitle: 'h1',
        },
      },
      styleOverrides: {
        gutterBottom: {
          marginBottom: theme.spacing(1),
        },
        // Metrics and counts read as data, and stay aligned while they update.
        overline: {
          fontVariantNumeric: 'tabular-nums',
        },
        caption: {
          fontVariantNumeric: 'tabular-nums',
        },
      },
    },
  }
}
